import getOvertimeSummary from './queries/getOvertimeSummary';

const queries = {
  getOvertimeSummary,
};

export const overtimeApis = {
  queries,
};

